export default __webpack_public_path__ + "static/media/teacher_two.9b855cd7.png";